/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MetamodelMe } from '../../models/metamodel-me';

export interface CreateNodeType$Params {
      body: MetamodelMe
}

export function createNodeType(http: HttpClient, rootUrl: string, params: CreateNodeType$Params, context?: HttpContext): Observable<StrictHttpResponse<MetamodelMe>> {
  const rb = new RequestBuilder(rootUrl, createNodeType.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MetamodelMe>;
    })
  );
}

createNodeType.PATH = '/api/MetaModel';
